import React, { useContext } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import VistaDescripcion from "../vistas/VistaDescripcionObra";
import FormDescripcion from "../formularios/FormDescripcionObra";
// Contexto
import { ModalContext } from "../../../../context/modalContext";

const DescripcionObra = ({ descripcionMision, handlePutDatosMision, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  return (
    <Accordion defaultActiveKey="0">
      <Card>
        <Card.Header>
          <Accordion.Toggle eventKey="0" as={Button} variant="link">
            Descripción
          </Accordion.Toggle>
          <Button
            variant="outline-primary"
            size="sm"
            className="float-right mr-4"
            onClick={() => {
              modalSetShow(true, "80%");
              modalSetTitle("Editar descripción misión");
              modalSetContent(<FormDescripcion defaultValues={{ description: descripcionMision }} submissionHandler={handlePutDatosMision} />);
            }}
          >
            Editar
          </Button>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className={"bg-light"}>
            <VistaDescripcion descripcionMision={descripcionMision} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default DescripcionObra;
